<template>
    <div>
        <template v-if="crud_role == true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Edit Role</h1>
            </div>
            <div class="company-main">
                <form @submit.prevent="editRole">
                    <div class="tab-content-inner">
                        <template v-if="permissions != null">
                            <div class="people-management-inner-content p-5">
                                
                                <div class="user-permissions">
                                    <div class="form-group">
                                        <label>Name</label>
                                        <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" />
                                        <has-error :form="form" field="username"></has-error>
                                    </div>
                                    <div class="form-group" v-for="(permission, index) in permissions" v-bind:key="permission.id">
                                        <label class="label block-label"> <span class="highlight-color">{{index}}</span> </label>
                                        <div class="permissions-box">
                                            <div class="row">
                                                <div class="col-md-4 mb-2" v-for="child in permission">
                                                    <label class="check-holder ml-0">
                                                        <span class="check-text"> {{child.display_name}} </span> <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="child.description"></i>
                                                        <input type="checkbox" v-bind:value="child.id" v-bind:id="'permission_'+child.id" v-model="form.rolePermissions" />
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                                        <router-link to="/roles" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                                    </div>
                                </div>

                            </div>
                        </template>
                    </div>

                </form>
            </div>
        </template>
        <template v-if="crud_role == null">
            <preLoader></preLoader>
        </template>
        <template v-if="crud_role == false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form : new Form({
                    id: '',
                    name: '',
                    rolePermissions : [],
                }),
                permissions : null,
                crud_role : null,
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('manage_company_crud_role').then(result => {
                if(this.$route.params.id == 1){
                    this.crud_role = false;
                }else{
                    this.crud_role = result.manage_company_crud_role;
                }
                this.$Progress.finish();
            }).then(result => {
                if(this.crud_role == true){
                    this.getallPermissions();
                    this.$Progress.finish();
                }
            });
        },
        
        methods: {
            editRole() {
                this.$Progress.start();
                if(this.form.name == ''){
                    this.showAlertBox('error', 'Name field is required');
                    this.$Progress.finish();
                    return false;
                }
                this.form.put('/api/updateRole')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success', 'Role updated successfully');
                        this.$router.push('/roles');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error', 'Some problem in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error', 'Some problem in your form data');
                });
            },

            getallPermissions(){
                this.$Progress.start();
                axios.get('/api/editRole/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.name = res.data.role.name;
                        this.form.id = res.data.role.id;
                        this.permissions = res.data.permissions;
                        $.each(res.data.rolePermissions, (key, value) => {
                            this.form.rolePermissions.push(value.id);
                        });
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error', 'Some problem in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error', 'Some problem in your form data');
                });
            }
        }
    }
</script>
